import store from '@/store/index.js'
import { operationEnums } from 'apis/common'

/**
 * 初始化全部接口请求
 */
const initData = async () => {
  let dictionaries = sessionStorage.getItem('dictionaries') ? JSON.parse(sessionStorage.getItem('dictionaries')) : {}
  if (Object.keys(dictionaries).length > 2) {
    store.commit('setDictionaries', dictionaries)
    return new Promise((res) => {
      res()
    })
  } else {
    if (window.location.pathname != '/login') {
      await initDictionary()
      return new Promise((res) => {
        res()
      })
    }
  }
}

const baseDictionaries = {
  statusEnum: [
    {
      code: 0,
      name: '停用',
    },
    {
      code: 1,
      name: '启用',
    },
  ],
  upperLowerEnum: [
    {
      code: 0,
      name: '下架',
    },
    {
      code: 1,
      name: '上架',
    },
  ],
  statusDescEnum: [
    {
      code: 0,
      name: '已停用',
    },
    {
      code: 1,
      name: '使用中',
    },
  ],
}

/**
 * 字典表
 */
const initDictionary = async () => {
  let res = await operationEnums({ timeout: 6000 })
  if (res) {
    res = { ...res, ...baseDictionaries }
    store.commit('setDictionaries', enumsFormat(res))
    sessionStorage.setItem('dictionaries', JSON.stringify(enumsFormat(res)))
  }
}

/**
 * 枚举数据转化
 * @param data
 * @returns {{}}
 */
function enumsFormat(data) {
  let result = {}
  if (!data) return false
  for (const [key, value] of Object.entries(data)) {
    result[key] = {
      data: value,
      dataForName: arrayForKeyToObject(value, { key: 'name', value: 'code' }),
      dataForCode: arrayForKeyToObject(value),
    }
  }
  return result
}

/**
 * 数组对象提取成对象
 * 传入参数 [{name:aaa,value:1},{name:aaa,value:1}]
 * 返回结果 [{name:1},{name:1}]
 * @param data
 * @param object
 * @returns {[]}
 */
function arrayForKeyToObject(data, object = { key: 'code', value: 'name' }) {
  let res = {}
  data.forEach((item) => {
    let o = {}
    o[item[object.key]] = item[object.value]
    res = { ...res, ...o }
  })
  return res
}

export default initData
export { initData, initDictionary }
